"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactI18next = require("react-i18next");

var _TextField = _interopRequireDefault(require("../TextField"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var Number = function Number(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var min = props.min,
      max = props.max,
      step = props.step,
      required = props.required,
      requiredError = props.requiredError;

  var validation = function validation(value) {
    var error;

    if (required && !value) {
      error = requiredError || t('webform.required');
    }

    if (min && parseInt(value) < min) {
      error = t('webform.number.min', {
        min: min
      });
    }

    if (max && parseInt(value) > max) {
      error = t('webform.number.max', {
        max: max
      });
    }

    return error;
  };

  return /*#__PURE__*/_react.default.createElement(_TextField.default, _extends({}, props, {
    type: "number",
    validation: validation,
    min: min,
    max: max,
    step: step
  }));
};

var _default = Number;
exports.default = _default;